module.exports = __webpack_public_path__ + "static/media/30_B.c95bf747.png";